import { render, staticRenderFns } from "./ImpressosSegurancaRelatoriosDetalhes.vue?vue&type=template&id=6e65dd85&"
import script from "./ImpressosSegurancaRelatoriosDetalhes.vue?vue&type=script&lang=js&"
export * from "./ImpressosSegurancaRelatoriosDetalhes.vue?vue&type=script&lang=js&"
import style0 from "./ImpressosSegurancaRelatoriosDetalhes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports